module.exports = __webpack_public_path__ + "static/story5-01-533x800-682fd90c3f43421fb71809c3b4dd176a.jpg";